<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3EA56E" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog
      max-width="800px"
      v-model="imageDialog"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" style="cursor: pointer" color="#ffffff"
          >mdi-square-edit-outline</v-icon
        >
      </template>
      <v-card>
        <v-layout pa-2 wrap>
          <v-flex xs12 lg12>
            <v-layout py-5 wrap>
              <v-flex xs12>
                <span
                  style="
                    font-family: opensanssemibold;
                    font-size: 18px;
                    color: #1c1c1c;
                    letter-spacing: 0.54px;
                  "
                >
                  Profile Picture
                </span>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex pb-2 xs12 lg8>
                <v-img
                  :src="proPicImg ? proPicImg : mediaURL + appUser.image"
                  aspect-ratio="1"
                  contain
                  height="200px"
                >
                </v-img>
              </v-flex>
              <v-flex align-self-center xs12 lg2>
                <v-layout row wrap>
                  <v-flex xs12>
                    <span>
                      <v-btn
                        tile
                        depressed
                        small
                        :ripple="false"
                        id="pro_pic"
                        class="text-capitalize"
                        color="#EFEFEF "
                        @click="$refs.files.click()"
                      >
                        <v-layout wrap justify-center>
                          <v-flex xs12>
                            <span
                              style="
                                font-size: 12px;
                                font-family: opensanssemibold;
                              "
                              >Upload Image <v-icon>mdi-upload</v-icon></span
                            >
                          </v-flex>
                        </v-layout>
                      </v-btn>
                      <input
                        v-show="false"
                        accept="image/*"
                        id="file"
                        ref="files"
                        multiple="multiple"
                        type="file"
                        @change="uploadProPicImg"
                      />
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12>
            <v-layout py-5 wrap>
              <v-flex xs12>
                <span
                  style="
                    font-family: opensanssemibold;
                    font-size: 18px;
                    color: #1c1c1c;
                    letter-spacing: 0.54px;
                  "
                >
                  Cover Image
                </span>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="appUser">
              <v-flex pb-2 xs12 lg8>
                <v-layout wrap v-if="appUser.seller">
                  <v-flex xs12 v-if="appUser.seller.coverimage">
                    <v-img
                      :src="
                        coverPicImg
                          ? coverPicImg
                          : mediaURL + appUser.seller.coverimage
                      "
                      aspect-ratio="1"
                      contain
                      height="200px"
                    >
                    </v-img>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex align-self-center xs12 lg2>
                <v-layout row wrap>
                  <v-flex xs12>
                    <span>
                      <v-btn
                        tile
                        depressed
                        small
                        :ripple="false"
                        id="pro_pic"
                        class="text-capitalize"
                        color="#EFEFEF "
                        @click="$refs.files2.click()"
                      >
                        <v-layout wrap justify-center>
                          <v-flex xs12>
                            <span
                              style="
                                font-size: 12px;
                                font-family: opensanssemibold;
                              "
                              >Upload Cover <v-icon>mdi-upload</v-icon></span
                            >
                          </v-flex>
                        </v-layout>
                      </v-btn>
                      <input
                        v-show="false"
                        accept="image/*"
                        id="file"
                        ref="files2"
                        multiple="multiple"
                        type="file"
                        @change="uploadCoverPicImg"
                      />
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            tile
            color="#757575"
            depressed
            :ripple="false"
            class="text-capitalize"
            @click="
              imageDialog = false;
              proPicImg = '';
              coverPicImg = '';
            "
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            dark
            color="#3EA56E"
            depressed
            class="text-capitalize"
            :ripple="false"
            @click="uploadImages()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap justify-start>
      <v-flex xs12 xl11>
        <v-layout wrap justify-center pb-4 px-2 px-sm-4>
          <v-flex xs12>
            <v-layout wrap justify-start>
              <v-flex xs7 sm3 md3 lg2 xl2>
                <v-layout wrap justify-center>
                  <!-- <v-flex xs3 sm2 text-left align-self-center>
                    <v-img
                      src="./../../assets/icon.png"
                      contain
                      height="15px"
                    ></v-img>
                  </v-flex> -->
                  <v-flex xs12 lg12 text-left pl-0 align-self-center>
                    <span
                      style="
                        font-family: ibmsemibold;
                        font-size: 18px;
                        color: #1c1c1c;
                      "
                    >
                      Profile
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex pt-2 xs12>
            <!-- Banner Section -->
            <v-flex xs12 lg12 md12 v-if="flag">
              <v-layout wrap v-if="seller.seller">
                <v-flex xs12 v-if="seller.seller.coverimage">
                  <v-img
                    :src="mediaURL + seller.seller.coverimage"
                    height="357px"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="#3EA56E"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                    <v-layout justify-space-between fill-height wrap v-if="seller.image">
                      <v-flex pb-7 align-self-end xs2>
                        <v-avatar size="80">
                          <v-img :src="mediaURL + seller.image" cover>
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="#3EA56E"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </v-flex>
                      <v-flex pr-3 pb-3 text-right align-self-end xs1 lg1>
                        <!-- Dialogue -->
                        <v-icon
                          @click="imageDialog = true"
                          style="cursor: pointer"
                          color="#ffffff"
                          >mdi-square-edit-outline</v-icon
                        >
                      </v-flex>
                    </v-layout>
                  </v-img>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
          <v-flex xs12 pl-2>
            <v-layout wrap justify-space-between>
              <v-flex xs6 text-left>
                <v-layout wrap justify-start>
                  <v-flex xs12>
                    <span
                      style="
                        font-family: kumbhsansbold;
                        font-size: 15px;
                        color: #000000;
                      "
                    >
                      {{ appUser.organization }}
                    </span>
                  </v-flex>
                  <v-flex xs12>
                    <v-icon color="#000000" size="12px">mdi-map-marker</v-icon>
                    <span
                      style="
                        font-family: kumbhsansregular;
                        font-size: 12px;
                        color: #787676;
                      "
                    >
                      {{ appUser.locality }},&nbsp;
                      {{ appUser.streetAddress }},&nbsp;
                      {{ appUser.city }},&nbsp; {{ appUser.district }},&nbsp;
                      {{ appUser.state }},&nbsp;
                      {{ appUser.pincode }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 text-right>
                <span class="pr-1" v-if="appUser.seller">
                  <a :href="appUser.seller.facebook">
                    <v-icon color="#9D9C9C" size="22px">mdi-facebook</v-icon>
                  </a>
                </span>
                <span class="pl-1" v-if="appUser.seller">
                  <a :href="appUser.seller.instagram">
                    <v-icon color="#9D9C9C" size="22px">mdi-instagram</v-icon>
                  </a>
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <!-- Profile Details -->
            <v-layout wrap justify-center pt-2>
              <v-flex xs12 sm8 md8 lg6 xl4>
                <v-layout wrap>
                  <v-flex text-left xs12 lg12>
                    <span class="styloopinputlabel pl-0">
                      Name of the Company/Shop
                    </span>
                    <v-text-field
                      color="#3EA56E"
                      dense
                      v-model="seller.organization"
                      placeholder="Name of Shop"
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex text-left xs12 lg12>
                    <span class="styloopinputlabel pl-0">
                      Name of the owner
                    </span>
                    <v-text-field
                      color="#3EA56E"
                      dense
                      placeholder="Name of owner"
                      v-model="seller.ownername"
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex text-left xs12 lg12>
                    <span class="styloopinputlabel pl-0">Address Line</span>
                    <v-card class="mx-auto mb-6" outlined>
                      <v-layout wrap pa-3>
                        <v-flex xs12 md12 lg12>
                          <v-layout wrap justify-start>
                            <v-flex xs12 px-2>
                              <span class="styloopinputlabel pl-0">
                                Address of the Owner
                              </span>
                              <v-text-field
                                ref="streetAddress"
                                color="#3EA56E"
                                placeholder="Address of the Owner"
                                dense
                                v-model="seller.streetAddress"
                                disabled
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6 px-2>
                              <span class="styloopinputlabel pl-0">
                                Locality
                              </span>
                              <v-text-field
                                ref="locality"
                                color="#3EA56E"
                                placeholder="Locality"
                                dense
                                v-model="seller.locality"
                                disabled
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs6 px-2>
                              <span class="styloopinputlabel pl-0">City</span>
                              <v-text-field
                                ref="city"
                                color="#3EA56E"
                                placeholder="City"
                                dense
                                v-model="seller.city"
                                disabled
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6 px-2>
                              <span class="styloopinputlabel pl-0">
                                District
                              </span>
                              <v-text-field
                                ref="district"
                                color="#3EA56E"
                                placeholder="District"
                                dense
                                v-model="seller.district"
                                disabled
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs6 px-2>
                              <span class="styloopinputlabel pl-0">State</span>
                              <v-text-field
                                ref="state"
                                color="#3EA56E"
                                placeholder="State"
                                dense
                                v-model="seller.state"
                                disabled
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6 px-2>
                              <span class="styloopinputlabel pl-0">
                                Pincode
                              </span>
                              <v-text-field
                                type="number"
                                ref="pincode"
                                color="#3EA56E"
                                placeholder="Pincode"
                                dense
                                required
                                v-model="seller.pincode"
                                disabled
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <v-flex text-left xs12 lg12>
                    <v-card class="mx-auto" outlined>
                      <v-layout wrap pa-3>
                        <v-flex xs12 md12 lg12>
                          <v-layout wrap>
                            <v-flex xs12 text-left>
                              <span class="styloopinputlabel pl-0">
                                ID Proof
                              </span>
                            </v-flex>
                          </v-layout>
                          <v-layout pb-1 wrap justify-center pt-2>
                            <v-flex xs10 md9>
                              <span v-if="idproofpic">{{ idproofpic }}</span>
                            </v-flex>
                            <v-flex xs2 md3>
                              <span>
                                <v-dialog v-if="idproofpic">
                                  <template v-slot:activator="{ on }">
                                    <v-btn outlined rounded v-on="on" small>
                                      View
                                    </v-btn>
                                  </template>
                                  <v-card class="mx-auto my-auto">
                                    <v-toolbar elevate-on-scroll fixed>
                                      Id proof
                                    </v-toolbar>
                                    <v-divider></v-divider>
                                    <v-layout wrap>
                                      <v-flex xs12 lg12>
                                        <iframe
                                          v-if="idproofpic"
                                          id="idproofpic"
                                          :src="mediaURL + idproofpic"
                                          height="700px"
                                          width="900px"
                                          contain
                                        >
                                        </iframe>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-dialog>
                              </span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <v-flex pt-4 text-left xs12 lg12>
                    <span class="styloopinputlabel">Bank Details</span>
                    <v-card class="mx-auto" outlined>
                      <v-layout wrap pa-3>
                        <v-flex xs12 md12 lg12>
                          <span class="styloopinputlabel pl-0">Bank</span>
                          <v-text-field
                            ref="bank"
                            color="#3EA56E"
                            placeholder="Bank"
                            dense
                            :rules="[rules.required]"
                            v-model="seller.bankname"
                            disabled
                          ></v-text-field>
                          <span class="styloopinputlabel pl-0">
                            Account Holder
                          </span>
                          <v-text-field
                            ref="accountholder"
                            color="#3EA56E"
                            placeholder="Account Holder"
                            dense
                            :rules="[rules.required]"
                            v-model="seller.accountholder"
                            disabled
                          ></v-text-field>

                          <span class="styloopinputlabel pl-0">
                            Account Number
                          </span>
                          <v-text-field
                            ref="accountnumber"
                            color="#3EA56E"
                            placeholder="Account Number"
                            dense
                            :rules="[rules.required]"
                            v-model="seller.accountnumber"
                            disabled
                          ></v-text-field>
                          <v-layout wrap>
                            <v-flex xs6 px-2>
                              <span class="styloopinputlabel pl-0">
                                IFSC Code
                              </span>
                              <v-text-field
                                ref="ifsc"
                                color="#3EA56E"
                                placeholder="IFSC Code"
                                dense
                                :rules="[rules.required]"
                                v-model="seller.ifsccode"
                                disabled
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs6 px-2>
                              <span class="styloopinputlabel pl-0">Branch</span>
                              <v-text-field
                                ref="branch"
                                color="#3EA56E"
                                placeholder="Branch"
                                dense
                                required
                                :rules="[rules.required]"
                                v-model="seller.branch"
                                disabled
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <v-flex pt-4 text-left xs12>
                    <span class="styloopinputlabel">Email</span>
                    <v-text-field
                      ref="email"
                      color="#3EA56E"
                      placeholder="Email Id"
                      outlined
                      dense
                      :rules="[rules.required]"
                      v-model="seller.email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex text-left xs12 lg12>
                    <span class="styloopinputlabel">Phone number</span>
                    <v-text-field
                      ref="phone"
                      color="#3EA56E"
                      placeholder="Whatsapp number"
                      outlined
                      dense
                      :rules="[rules.required]"
                      type="number"
                      v-model="seller.phone"
                    >
                      <template v-slot:prepend-inner>
                        <v-layout wrap justify-center>
                          <v-flex pt-1 xs18 class="align-self-center">
                            <span
                              style="
                                font-family: ibmregular;
                                font-size: 14px;
                                color: #000;
                              "
                              >+91</span
                            >
                          </v-flex>
                          <v-flex pl-2 xs1>
                            <v-divider vertical></v-divider>
                          </v-flex>
                        </v-layout>
                        <v-card class="mx-auto" outlined></v-card>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex text-left xs12 lg12>
                    <span class="styloopinputlabel">Whatsapp number</span>
                    <v-text-field
                      ref="phone"
                      color="#3EA56E"
                      placeholder="Whatsapp number"
                      outlined
                      dense
                      :rules="[rules.required]"
                      type="number"
                      v-model="seller.whatsapp"
                    >
                      <template v-slot:prepend-inner>
                        <v-layout wrap justify-center>
                          <v-flex pt-1 xs18 class="align-self-center">
                            <span
                              style="
                                font-family: ibmregular;
                                font-size: 14px;
                                color: #000;
                              "
                              >+91</span
                            >
                          </v-flex>
                          <v-flex pl-2 xs1>
                            <v-divider vertical></v-divider>
                          </v-flex>
                        </v-layout>
                        <v-card class="mx-auto" outlined></v-card>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex text-left xs12 lg12>
                    <span class="styloopinputlabel">Instagram URL</span>
                    <v-text-field
                      ref="email"
                      color="#3EA56E"
                      placeholder="Instagram URL"
                      outlined
                      dense
                      v-model="seller.instagram"
                    ></v-text-field>
                  </v-flex>
                  <v-flex text-left xs12 lg12>
                    <span class="styloopinputlabel">Facebook URL</span>
                    <v-text-field
                      ref="email"
                      color="#3EA56E"
                      placeholder="Facebook URL"
                      outlined
                      dense
                      v-model="seller.facebook"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12 pt-2 pb-4>
                    <v-btn
                      tile
                      block
                      dark
                      color="#3EA56E"
                      depressed
                      class="text-capitalize"
                      @click.prevent="validateInput"
                      :ripple="false"
                      >Update</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      seller: {},
      imageDialog: false,
      proPicImg: null,
      proPic: null,
      idproofpic: null,
      coverPicture: null,
      coverPicImg: null,
      coverPic: null,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      flag:true,
      msg: "",
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
    };
  },
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    removeUploadPropic() {
      this.seller.image = "";
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.$store.commit("userData", response.data.data);
            this.seller = response.data.data;
            this.idproofpic = this.seller.seller.idproof[0];
            this.seller.ownername = this.seller.seller.ownername;
            this.seller.accountnumber = this.seller.seller.accountnumber;
            this.seller.accountholder = this.seller.seller.accountholder;
            this.seller.bankname = this.seller.seller.bankname;
            this.seller.ifsccode = this.seller.seller.ifsccode;
            this.seller.branch = this.seller.seller.branch;
            this.seller.facebook = this.seller.seller.facebook;
            this.seller.instagram = this.seller.seller.instagram;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadImages() {
      if (this.proPicImg) {
        this.uploadPic();
      }
      if (this.coverPicImg) {
        this.uploadCovPic(this.$store.state.userData._id);
      }
      this.imageDialog = false;
    },
    validateInput() {
      if (!this.seller.email) {
        this.msg = "Please provide Email id";
        this.showSnackBar = true;
        return;
      }
      if (!this.seller.phone) {
        this.msg = "Please provide the phone number";
        this.showSnackBar = true;
        return;
      }

      this.editProfile();
    },
    uploadProPicImg(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showSnackBar = true;
        return;
      }
      this.proPic = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.proPicImg = e.target.result;
      };
      this.proPicSts = true;
      this.newProfilepic = true;
      reader.readAsDataURL(files[0]);
    },

    uploadCoverPicImg(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 1145728) {
        this.msg = "File Should be less than 1MB";
        this.showSnackBar = true;
        return;
      }
      this.coverPic = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.coverPicImg = e.target.result;
      };
      this.coverPicSts = true;
      this.newCoverpic = true;
      reader.readAsDataURL(files[0]);
    },
    uploadPic() {
      var formData = new FormData();
      formData.append("photos", this.proPic);
      this.appLoading = true;
      axios({
        method: "post",
        url: "/user/uploadImage",
        data: formData,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            // this.$store.commit("changePicture", response.data.image);
            
            this.getData();

            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })

        .catch((e) => {
          console.log(e);
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    uploadCovPic(id) {
      this.appLoading = true;
      this.flag=false
      var formData = new FormData();
      formData.append("id", id);
      formData.append("image", this.coverPic);
      axios({
        method: "POST",
        url: "/User/seller/UploadCoverImage",
        data: formData,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.$store.commit(
              "changeCoverPicture",
              response.data.data.seller.coverimage
            );
            this.seller=response.data.data
            this.flag=true
            // this.getData();
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })

        .catch((e) => {
          console.log(e);
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    editProfile() {
      this.appLoading = true;
      var profileData = {};
      profileData["phone"] = this.seller.phone;
      profileData["whatsapp"] = this.seller.whatsapp;
      profileData["email"] = this.seller.email;
      profileData["instagram"] = this.seller.instagram;
      profileData["facebook"] = this.seller.facebook;
      profileData["id"] = this.$store.state.userData._id;

      axios({
        method: "POST",
        url: "/user/Edit",
        data: profileData,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Profile Updated";
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>